import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  VStack,
} from "@chakra-ui/react";
import { FormEventHandler, useCallback } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import useHomeworkState from "../../state/homework.state";
import { Category } from "../../utils/vtt";

export default function CategoryForm() {
  const { t } = useTranslation();
  const { addCategory } = useHomeworkState();
  const {
    handleSubmit,
    register,
    formState: { errors, isValid, isSubmitted },
  } = useForm<Category>();

  const _onSubmit: FormEventHandler<HTMLFormElement> = useCallback(
    (e) => {
      e.preventDefault();
      handleSubmit((category) =>
        addCategory({ ...category, uuid: uuidv4() }),
      )();
    },
    [addCategory, handleSubmit],
  );

  return (
    <form onSubmit={_onSubmit}>
      <FormControl isInvalid={!isValid && isSubmitted} display="flex" gap={4}>
        <VStack alignItems="stretch" flexGrow={1}>
          <div>
            <FormLabel htmlFor="name">{t("forms.name")}</FormLabel>
            <Input
              id="text"
              placeholder={t("forms.name")}
              {...register("name", {
                required: t("forms.validation.required"),
              })}
            />
            <FormErrorMessage>
              {errors.name && errors.name.message}
            </FormErrorMessage>
          </div>

          <div>
            <FormLabel htmlFor="style">{t("forms.style")}</FormLabel>
            <Select id="style" {...register("style")}>
              <option value="">-</option>
              {["italic", "bold"].map((style) => (
                <option key={style} value={style}>
                  {style}
                </option>
              ))}
            </Select>
            <FormErrorMessage>
              {errors.style && errors.style.message}
            </FormErrorMessage>
          </div>
        </VStack>
        <Box flexGrow={1}>
          <FormLabel htmlFor="color">{t("forms.color")}</FormLabel>
          <Input
            id="color"
            type="color"
            placeholder="Colore"
            {...register("color", {
              required: t("forms.validation.required"),
            })}
          />
          <FormErrorMessage>
            {errors.color && errors.color.message}
          </FormErrorMessage>
        </Box>
      </FormControl>
      <Button mt={4} bg="primary.DEFAULT" color="white" type="submit">
        {t("common.buttons.new")}
      </Button>
    </form>
  );
}
